<!--
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 -->

<template>
  <div
    class="flex bg-gray-800 border-b border-gray-800 py-0.5 justify-between items-center w-full"
  >
    <div class="flex mr-auto">
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/">{{
        $t('message.sketches')
      }}</router-link>
      <router-link
        v-show="hasAdminAccess"
        class="mr-4 px-2 text-gray-300"
        style="text-decoration: none;"
        to="/administration"
        >{{ $t('message.administration') }}</router-link
      >
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/data">{{
        $t('message.data')
      }}</router-link>
      <router-link
        v-show="hasConfigAccess"
        class="mr-4 px-2 text-gray-300"
        style="text-decoration: none;"
        to="/config"
        >{{ $t('config.title') }}</router-link
      >
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/worders">{{
        $t('message.worders')
      }}</router-link>
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/orders">{{
        $t('message.orders')
      }}</router-link>
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/dispatches">{{
        $t('message.dispatches')
      }}</router-link>
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/calculations">{{
        $t('message.calculations')
      }}</router-link>
      <router-link class="mr-4 px-2 text-gray-300" style="text-decoration: none;" to="/nesting">{{
        $t('message.nesting')
      }}</router-link>
      <router-link
        v-show="$router.hasRoute('Demo')"
        class="mr-4 px-2 text-gray-300"
        style="text-decoration: none;"
        to="/demo"
        >{{ $t('demo.title') }}</router-link
      >
    </div>
    <div class="flex ml-auto items-center">
      <div class="flex items-center">
        <span class="mr-2 text-gray-300 pr-2">{{ $t('common.language') }}</span>
        <Dropdown
          v-model="currentLocale"
          :options="locales"
          optionLabel="title"
          class="bg-gray-800 border-gray-800 focus:border-gray-800"
        >
          <template #value="slotProps">
            <div class="country-item">
              <img :src="slotProps.value.flag" />
            </div>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <img :src="slotProps.option.flag" />
            </div>
          </template>
        </Dropdown>
      </div>
      <span v-if="authStore.clientName" class="text-gray-300 mx-4 text-sm font-medium">
        {{ authStore.clientName }}
      </span>
      <router-link to="/profile" custom v-slot="{ navigate }">
        <div
          class="flex flex-row mr-4 px-2 text-gray-300"
          style="cursor: pointer"
          @click="navigate"
        >
          <div><font-awesome-icon icon="user-gear" /></div>
          <span class="pl-1">{{ authStore.userName }}</span>
        </div>
      </router-link>
      <router-link class="mr-4 px-2 text-gray-300" to="/logout"
        ><font-awesome-icon icon="right-from-bracket"
      /></router-link>
    </div>
  </div>
</template>

<script lang="ts">
  import s from './scripts/Navbar';
  export default s;
</script>
<style lang="scss" scoped>
  /* purgecss ignore */
  .router-link-active {
    @apply bg-gray-700 text-green-400;
  }

  .country-item {
    img {
      height: 15px;
      margin-right: 0.5rem;
    }
  }
</style>
